import Modal from './modal.js';

class BookingForm {
    constructor() {
        this.modal = new Modal('bookingModal');
        this.modalElement = document.getElementById('bookingModal');
        this.form = document.getElementById('bookingForm');
        this.timeSlotsContainer = document.getElementById('timeSlots');
        this.peopleCountInput = document.getElementById('peopleCount');
        this.userNameInput = document.getElementById('userName');
        this.userPhoneInput = document.getElementById('userPhone');
        this.userEmailInput = document.getElementById('userEmail');
        this.specialNeedsInput = document.getElementById('specialNeeds');
        this.bookingDateEl = document.getElementById('bookingDate');
        this.submitBtn = document.getElementById('bookingSubmit');
        this.dateEditBtn = document.querySelector('.booking-modal__date-edit');
        
        this.selectedDate = null;
        this.selectedTimeSlots = [];
        this.timeSlotsData = {};
        this.settings = null;
        this.priceElement = document.getElementById('bookingPrice');
        this.priceOldElement = document.getElementById('bookingPriceOld');
        this.discountElement = document.getElementById('bookingDiscount');
        this.priceRowElement = document.querySelector('.booking-modal__price-row');
        this.priceWrapper = document.querySelector('.booking-modal__price');
        this.discountReasonElement = document.getElementById('bookingDiscountReason');
        this.errorsContainer = document.getElementById('bookingErrors');
        this.disclaimerCheckbox = document.getElementById('bookingDisclaimer');
        this.hasCertificateCheckbox = document.getElementById('hasCertificate');
        this.certificateFieldWrapper = document.getElementById('certificateFieldWrapper');
        this.certificateCodeInput = document.getElementById('certificateCode');
        this.applyCertificateBtn = document.getElementById('applyCertificateBtn');
        this.certificateNotificationElement = document.getElementById('bookingCertificateNotification');
        this.appliedCertificate = null;
        this.errors = {};
        
        this.loadSettings();
        this.init();
    }
    
    init() {
        if (this.dateEditBtn) {
            this.dateEditBtn.addEventListener('click', () => {
                this.modal.close();
            });
        }
        
        if (this.peopleCountInput) {
            const decreaseBtn = this.modalElement.querySelector('[data-action="decrease"]');
            const increaseBtn = this.modalElement.querySelector('[data-action="increase"]');
            
            if (decreaseBtn) {
                decreaseBtn.addEventListener('click', () => this.changePeopleCount(-1));
            }
            
            if (increaseBtn) {
                increaseBtn.addEventListener('click', () => this.changePeopleCount(1));
            }
            
            this.peopleCountInput.addEventListener('keydown', (e) => {
                e.preventDefault();
            });
            
            this.peopleCountInput.addEventListener('paste', (e) => {
                e.preventDefault();
            });
            
            this.peopleCountInput.addEventListener('wheel', (e) => {
                e.preventDefault();
            });
            
            this.peopleCountInput.addEventListener('input', (e) => {
                const currentValue = parseInt(this.peopleCountInput.value) || 1;
                let maxValue = this.getMaxPeopleForSelectedSlots();
                let newValue = currentValue;
                
                if (this.appliedCertificate && this.appliedCertificate.sessions) {
                    const certificateSessions = this.appliedCertificate.sessions;
                    maxValue = Math.min(certificateSessions, maxValue);
                }
                
                if (isNaN(currentValue) || currentValue < 1) {
                    newValue = 1;
                } else if (currentValue > maxValue) {
                    newValue = maxValue;
                }
                
                this.peopleCountInput.value = newValue;
                this.validatePeopleCount();
                this.updatePrice();
            });
        }
        
        if (this.userNameInput) {
            this.userNameInput.addEventListener('input', () => {
                this.clearFieldError(this.userNameInput);
            });
        }
        
        if (this.userPhoneInput) {
            this.userPhoneInput.addEventListener('input', (e) => {
                this.formatPhoneInput(e.target);
                this.clearFieldError(this.userPhoneInput);
            });
        }
        
        if (this.userEmailInput) {
            this.userEmailInput.addEventListener('input', () => {
                this.clearFieldError(this.userEmailInput);
            });
        }
        
        if (this.hasCertificateCheckbox) {
            this.hasCertificateCheckbox.addEventListener('change', (e) => {
                if (e.target.checked) {
                    if (this.certificateFieldWrapper) {
                        this.certificateFieldWrapper.style.display = 'block';
                    }
                } else {
                    if (this.certificateFieldWrapper) {
                        this.certificateFieldWrapper.style.display = 'none';
                    }
                    this.appliedCertificate = null;
                    if (this.certificateCodeInput) {
                        this.certificateCodeInput.value = '';
                    }
                    if (this.applyCertificateBtn) {
                        this.applyCertificateBtn.disabled = false;
                        const btnText = this.applyCertificateBtn.querySelector('.btn__text');
                        const iconEdit = this.applyCertificateBtn.querySelector('.btn__icon--edit');
                        const iconCheck = this.applyCertificateBtn.querySelector('.btn__icon--check');
                        if (btnText) {
                            btnText.textContent = 'Застосувати';
                        }
                        if (iconEdit) iconEdit.style.display = 'inline-block';
                        if (iconCheck) iconCheck.style.display = 'none';
                    }
                    this.hideCertificateNotification();
                    this.updateSlotsAvailability();
                    this.updatePrice();
                    this.updatePaymentMethodVisibility();
                }
            });
        }
        
        if (this.applyCertificateBtn) {
            this.applyCertificateBtn.addEventListener('click', () => {
                this.checkCertificate();
            });
        }
        
        if (this.certificateCodeInput) {
            const prefix = 'POZ-';
            
            this.certificateCodeInput.addEventListener('focus', (e) => {
                const value = e.target.value;
                if (!value.startsWith(prefix)) {
                    if (value.length === 0) {
                        e.target.value = prefix;
                        const cursorPos = prefix.length;
                        e.target.setSelectionRange(cursorPos, cursorPos);
                    } else {
                        const cleaned = value.replace(/^POZ-?/i, '');
                        e.target.value = prefix + cleaned;
                        const cursorPos = Math.min(prefix.length + cleaned.length, 13);
                        e.target.setSelectionRange(cursorPos, cursorPos);
                    }
                }
            });
            
            this.certificateCodeInput.addEventListener('paste', (e) => {
                e.preventDefault();
                const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                let cleaned = pastedText.toUpperCase().replace(/[^A-Z0-9-]/g, '');
                
                if (cleaned.startsWith(prefix)) {
                    cleaned = cleaned.substring(prefix.length);
                } else if (cleaned.startsWith('POZ')) {
                    cleaned = cleaned.substring(3).replace(/^-/, '');
                }
                
                const currentValue = e.target.value;
                const hasPrefix = currentValue.startsWith(prefix);
                const baseValue = hasPrefix ? prefix : '';
                const maxLength = 13 - baseValue.length;
                
                if (cleaned.length > maxLength) {
                    cleaned = cleaned.substring(0, maxLength);
                }
                
                e.target.value = baseValue + cleaned;
                const cursorPos = Math.min(e.target.value.length, 13);
                e.target.setSelectionRange(cursorPos, cursorPos);
                
                if (this.appliedCertificate) {
                    this.resetCertificateState();
                }
                
                const inputEvent = new Event('input', { bubbles: true });
                e.target.dispatchEvent(inputEvent);
            });
            
            this.certificateCodeInput.addEventListener('keydown', (e) => {
                const value = e.target.value;
                const selectionStart = e.target.selectionStart;
                const selectionEnd = e.target.selectionEnd;
                
                if (value.startsWith(prefix)) {
                    if (e.key === 'Backspace' && selectionStart <= prefix.length && selectionStart === selectionEnd) {
                        e.preventDefault();
                        return;
                    }
                    if (e.key === 'Delete' && selectionStart < prefix.length && selectionStart === selectionEnd) {
                        e.preventDefault();
                        return;
                    }
                }
            });
            
            this.certificateCodeInput.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    this.checkCertificate();
                    return;
                }
                
                const value = e.target.value;
                if (value.length >= 13) {
                    if (e.target.selectionStart < 13 || e.target.selectionEnd < 13) {
                        if (e.key.length === 1) {
                            e.preventDefault();
                        }
                    }
                }
            });
            
            let previousValue = this.certificateCodeInput.value;
            this.certificateCodeInput.addEventListener('input', (e) => {
                let currentValue = e.target.value.toUpperCase();
                
                if (!currentValue.startsWith(prefix)) {
                    if (currentValue.length > 0 && !currentValue.includes('POZ')) {
                        currentValue = prefix + currentValue.replace(/[^A-Z0-9]/g, '');
                    } else if (currentValue.replace(/^POZ-?/i, '').length > 0) {
                        currentValue = prefix + currentValue.replace(/^POZ-?/i, '').replace(/[^A-Z0-9]/g, '');
                    } else {
                        currentValue = prefix;
                    }
                } else {
                    currentValue = prefix + currentValue.substring(prefix.length).replace(/[^A-Z0-9]/g, '');
                }
                
                if (currentValue.length > 13) {
                    currentValue = currentValue.substring(0, 13);
                }
                
                if (currentValue !== e.target.value) {
                    const cursorPos = Math.min(e.target.selectionStart, currentValue.length);
                    e.target.value = currentValue;
                    e.target.setSelectionRange(cursorPos, cursorPos);
                }
                
                if (currentValue.length < previousValue.length || currentValue !== previousValue) {
                    if (this.appliedCertificate) {
                        this.resetCertificateState();
                    }
                }
                previousValue = currentValue;
            });
        }
        
        if (this.form) {
            this.form.addEventListener('change', (e) => {
                if (e.target && e.target.name === 'paymentMethod' && e.target.type === 'radio') {
                    this.updatePrice();
                }
            });
            
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                
                if (this.submitBtn && this.submitBtn.disabled) {
                    return;
                }
                
                this.handleSubmit();
            });
        }
    }
    
    getUrlParameter(name) {
        const hash = window.location.hash;
        if (!hash || !hash.includes('?')) {
            return null;
        }
        
        const hashParts = hash.split('?');
        if (hashParts.length < 2) {
            return null;
        }
        
        const params = new URLSearchParams(hashParts[1]);
        return params.get(name);
    }
    
    async open(date, dateData) {
        this.selectedDate = date;
        this.timeSlotsData = dateData.timeSlots || {};
        this.selectedTimeSlots = [];
        
        if (this.bookingDateEl) {
            const monthNames = ['січня', 'лютого', 'березня', 'квітня', 'травня', 'червня', 
                               'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'];
            this.bookingDateEl.textContent = `${date.day} ${monthNames[date.month]}`;
        }
        
        this.hidePrice();
        this.resetForm();
        this.renderTimeSlots();
        this.updatePaymentMethodVisibility();
        this.modal.open();
        
        const certificateCode = this.getUrlParameter('certificate_code');
        if (certificateCode && this.hasCertificateCheckbox && this.certificateCodeInput) {
            this.hasCertificateCheckbox.checked = true;
            if (this.certificateFieldWrapper) {
                this.certificateFieldWrapper.style.display = 'block';
            }
            
            this.certificateCodeInput.value = certificateCode.toUpperCase();
            
            setTimeout(() => {
                this.checkCertificate();
            }, 300);
        }
    }
    
    renderTimeSlots() {
        if (!this.timeSlotsContainer) return;
        
        this.timeSlotsContainer.innerHTML = '';
        
        const timeSlots = [];
        const slotKeys = Object.keys(this.timeSlotsData).sort();
        
        slotKeys.forEach(slotKey => {
            const [hour, minute] = slotKey.split(':');
            const nextHour = String(parseInt(hour) + 1).padStart(2, '0');
            const displaySlot = `${slotKey}-${nextHour}:${minute}`;
            timeSlots.push({
                key: slotKey,
                display: displaySlot
            });
        });
        
        if (timeSlots.length === 0) {
            const noSlotsMsg = document.createElement('div');
            noSlotsMsg.className = 'booking-modal__no-slots';
            noSlotsMsg.textContent = 'Немає доступних слотів для цієї дати';
            this.timeSlotsContainer.appendChild(noSlotsMsg);
            return;
        }
        
        const midPoint = Math.ceil(timeSlots.length / 2);
        const leftColumn = timeSlots.slice(0, midPoint);
        const rightColumn = timeSlots.slice(midPoint);
        
        const leftColumnContainer = document.createElement('div');
        leftColumnContainer.className = 'booking-modal__time-slots-column';
        
        const rightColumnContainer = document.createElement('div');
        rightColumnContainer.className = 'booking-modal__time-slots-column';
        
        leftColumn.forEach((slot) => {
            const slotEl = this.createTimeSlotElement(slot);
            leftColumnContainer.appendChild(slotEl);
        });
        
        rightColumn.forEach((slot) => {
            const slotEl = this.createTimeSlotElement(slot);
            rightColumnContainer.appendChild(slotEl);
        });
        
        this.timeSlotsContainer.appendChild(leftColumnContainer);
        this.timeSlotsContainer.appendChild(rightColumnContainer);
        
        this.updateSlotsAvailability();
    }
    
    createTimeSlotElement(slot) {
        const slotData = this.timeSlotsData[slot.key];
        const available = slotData ? slotData.available : 0;
        
        const slotEl = document.createElement('label');
        slotEl.className = 'booking-modal__time-slot';
        if (available === 0) {
            slotEl.classList.add('booking-modal__time-slot--disabled');
        }
        
        slotEl.innerHTML = `
            <input type="checkbox" 
                   value="${slot.display}" 
                   data-slot-key="${slot.key}"
                   ${available === 0 ? 'disabled' : ''}
                   data-available="${available}">
            <svg class="booking-modal__checkbox-check" aria-hidden="true">
                <use href="#check"></use>
            </svg>
            <span class="booking-modal__time-slot-label">
                <span class="booking-modal__time-slot-time">${slot.display}</span>
                <span class="booking-modal__time-slot-places">
                    <span class="booking-modal__time-slot-dot"></span>
                    <span class="booking-modal__time-slot-places-text">${this.getPlacesText(available)}</span>
                </span>
            </span>
        `;
        
        const checkbox = slotEl.querySelector('input[type="checkbox"]');
        checkbox.addEventListener('change', (e) => {
            this.handleTimeSlotChange(slot.display, e.target.checked, available, slot.key);
        });
        
        return slotEl;
    }
    
    handleTimeSlotChange(slot, isChecked, available, slotKey) {
        const peopleCount = parseInt(this.peopleCountInput.value) || 1;
        
        if (isChecked) {
            if (available === 0 || available < peopleCount) {
                const checkbox = this.timeSlotsContainer.querySelector(`input[data-slot-key="${slotKey}"]`);
                if (checkbox) {
                    checkbox.checked = false;
                }
                return;
            }
            
            if (this.appliedCertificate && this.appliedCertificate.sessions) {
                const tempSelected = [...this.selectedTimeSlots, slot];
                const hours = tempSelected.length;
                const totalSessions = hours * peopleCount;
                const certificateSessions = this.appliedCertificate.sessions;
                
                if (totalSessions > certificateSessions) {
                    const checkbox = this.timeSlotsContainer.querySelector(`input[data-slot-key="${slotKey}"]`);
                    if (checkbox) {
                        checkbox.checked = false;
                    }
                    return;
                }
            }
            
            if (this.selectedTimeSlots.length === 0) {
                this.selectedTimeSlots.push(slot);
            } else {
                const tempSelected = [...this.selectedTimeSlots, slot];
                const sorted = this.getSortedSlotsFromArray(tempSelected);
                
                if (!this.validateSlotsContinuityFromArray(sorted)) {
                    this.selectedTimeSlots = [slot];
                    
                    const allCheckboxes = this.timeSlotsContainer.querySelectorAll('input[type="checkbox"]');
                    allCheckboxes.forEach(checkbox => {
                        checkbox.checked = checkbox.value === slot;
                    });
                } else {
                    this.selectedTimeSlots.push(slot);
                }
            }
            
            this.clearFormError();
        } else {
            this.selectedTimeSlots = this.selectedTimeSlots.filter(s => s !== slot);
            
            if (this.selectedTimeSlots.length > 0) {
                const sorted = this.getSortedSlots();
                if (!this.validateSlotsContinuityFromArray(sorted)) {
                    this.enforceSlotsContinuity();
                }
            }
            
            this.clearFormError();
        }
        this.updateSlotsAvailability();
        this.updatePrice();
    }
    
    getSortedSlotsFromArray(slots) {
        return [...slots].sort((a, b) => {
            const timeA = this.parseSlotTime(a);
            const timeB = this.parseSlotTime(b);
            if (!timeA || !timeB) return 0;
            return timeA.start - timeB.start;
        });
    }
    
    validateSlotsContinuityFromArray(sortedSlots) {
        if (sortedSlots.length === 0) {
            return true;
        }
        
        if (sortedSlots.length === 1) {
            return true;
        }
        
        for (let i = 0; i < sortedSlots.length - 1; i++) {
            const currentSlot = sortedSlots[i];
            const nextSlot = sortedSlots[i + 1];
            
            if (!this.areSlotsConsecutive(currentSlot, nextSlot)) {
                const slotsBetween = this.getSlotsBetween(currentSlot, nextSlot);
                const peopleCount = parseInt(this.peopleCountInput.value) || 1;
                
                const hasUnavailableSlot = slotsBetween.some(slotKey => {
                    const slotData = this.timeSlotsData[slotKey];
                    if (!slotData) return true;
                    const available = slotData.available;
                    return available === 0 || available < peopleCount;
                });
                
                if (hasUnavailableSlot) {
                    return false;
                }
            }
        }
        
        return true;
    }
    
    validateSlotsContinuity() {
        if (this.selectedTimeSlots.length === 0) {
            return true;
        }
        
        const sortedSlots = this.getSortedSlots();
        return this.validateSlotsContinuityFromArray(sortedSlots);
    }
    
    getSortedSlots() {
        return [...this.selectedTimeSlots].sort((a, b) => {
            const timeA = this.parseSlotTime(a);
            const timeB = this.parseSlotTime(b);
            return timeA.start - timeB.start;
        });
    }
    
    parseSlotTime(slot) {
        const match = slot.match(/(\d{2}):(\d{2})-(\d{2}):(\d{2})/);
        if (!match) return null;
        
        const startHour = parseInt(match[1]);
        const startMinute = parseInt(match[2]);
        const endHour = parseInt(match[3]);
        const endMinute = parseInt(match[4]);
        
        return {
            start: startHour * 60 + startMinute,
            end: endHour * 60 + endMinute,
            startHour,
            startMinute
        };
    }
    
    areSlotsConsecutive(slot1, slot2) {
        const time1 = this.parseSlotTime(slot1);
        const time2 = this.parseSlotTime(slot2);
        
        if (!time1 || !time2) return false;
        
        return time1.end === time2.start;
    }
    
    getSlotsBetween(slot1, slot2) {
        const time1 = this.parseSlotTime(slot1);
        const time2 = this.parseSlotTime(slot2);
        
        if (!time1 || !time2) return [];
        
        const slots = [];
        let currentTime = time1.end;
        
        while (currentTime < time2.start) {
            const hour = Math.floor(currentTime / 60);
            const minute = currentTime % 60;
            const slotKey = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
            slots.push(slotKey);
            currentTime += 60;
        }
        
        return slots;
    }
    
    enforceSlotsContinuity() {
        const sortedSlots = this.getSortedSlots();
        
        if (sortedSlots.length <= 1) {
            return;
        }
        
        let validSlots = [sortedSlots[0]];
        
        for (let i = 1; i < sortedSlots.length; i++) {
            const prevSlot = validSlots[validSlots.length - 1];
            const currentSlot = sortedSlots[i];
            
            if (this.areSlotsConsecutive(prevSlot, currentSlot)) {
                validSlots.push(currentSlot);
            } else {
                break;
            }
        }
        
        if (validSlots.length < this.selectedTimeSlots.length) {
            this.selectedTimeSlots = validSlots;
            
            const allCheckboxes = this.timeSlotsContainer.querySelectorAll('input[type="checkbox"]');
            allCheckboxes.forEach(checkbox => {
                checkbox.checked = validSlots.includes(checkbox.value);
            });
        }
    }
    
    validatePeopleCount() {
        const peopleCount = parseInt(this.peopleCountInput.value) || 1;
        let maxValue = this.getMaxPeopleForSelectedSlots();
        
        if (this.appliedCertificate && this.appliedCertificate.sessions) {
            const certificateSessions = this.appliedCertificate.sessions;
            maxValue = Math.min(certificateSessions, maxValue);
        }
        
        if (peopleCount > maxValue) {
            this.peopleCountInput.value = maxValue;
        }
        
        this.updateSlotsAvailability();
        
        const selectedSlots = this.timeSlotsContainer.querySelectorAll('input[type="checkbox"]:checked');
        selectedSlots.forEach(checkbox => {
            const available = parseInt(checkbox.dataset.available) || 0;
            if (available < peopleCount) {
                checkbox.checked = false;
                const slotKey = checkbox.dataset.slotKey;
                const slotDisplay = checkbox.value;
                this.selectedTimeSlots = this.selectedTimeSlots.filter(s => s !== slotDisplay);
            }
        });
        
        if (this.selectedTimeSlots.length > 0 && !this.validateSlotsContinuity()) {
            this.enforceSlotsContinuity();
        }
        
        if (this.appliedCertificate && this.appliedCertificate.sessions) {
            const hours = this.selectedTimeSlots.length;
            const totalSessions = hours * peopleCount;
            const certificateSessions = this.appliedCertificate.sessions;
            
            if (totalSessions > certificateSessions) {
                const maxHours = Math.floor(certificateSessions / peopleCount);
                const sortedSlots = this.getSortedSlots();
                
                while (this.selectedTimeSlots.length > maxHours && this.selectedTimeSlots.length > 0) {
                    const removedSlot = sortedSlots.pop();
                    this.selectedTimeSlots = this.selectedTimeSlots.filter(s => s !== removedSlot);
                    
                    const checkbox = this.timeSlotsContainer.querySelector(`input[value="${removedSlot}"]`);
                    if (checkbox) {
                        checkbox.checked = false;
                    }
                }
            }
        }
        
        this.updatePrice();
    }
    
    updateSlotsAvailability() {
        const peopleCount = parseInt(this.peopleCountInput.value) || 1;
        if (this.peopleCountInput) {
        this.peopleCountInput.max = this.getMaxPeopleForSelectedSlots();
        }
        const checkboxes = this.timeSlotsContainer.querySelectorAll('input[type="checkbox"]');
        
        checkboxes.forEach(checkbox => {
            const available = parseInt(checkbox.dataset.available) || 0;
            const slotEl = checkbox.closest('.booking-modal__time-slot');
            let shouldDisable = false;
            
            if (available < peopleCount) {
                shouldDisable = true;
            }
            
            if (this.appliedCertificate && this.appliedCertificate.sessions && !shouldDisable) {
                const certificateSessions = this.appliedCertificate.sessions;
                const currentSelected = this.selectedTimeSlots.filter(s => s !== checkbox.value);
                const wouldBeSelected = [...currentSelected, checkbox.value];
                const sortedWouldBe = this.getSortedSlotsFromArray(wouldBeSelected);
                const wouldBeSessions = sortedWouldBe.length * peopleCount;
                
                if (wouldBeSessions > certificateSessions) {
                    shouldDisable = true;
                } else if (sortedWouldBe.length > 1) {
                    const isValidContinuity = this.validateSlotsContinuityFromArray(sortedWouldBe);
                    if (!isValidContinuity) {
                        shouldDisable = true;
                    }
                }
            }
            
            if (shouldDisable) {
                checkbox.disabled = true;
                if (slotEl) {
                    slotEl.classList.add('booking-modal__time-slot--disabled');
                }
                if (checkbox.checked) {
                    checkbox.checked = false;
                    this.selectedTimeSlots = this.selectedTimeSlots.filter(s => s !== checkbox.value);
                }
            } else if (available > 0) {
                checkbox.disabled = false;
                if (slotEl) {
                    slotEl.classList.remove('booking-modal__time-slot--disabled');
                }
            }
        });
        
        if (this.selectedTimeSlots.length > 0 && !this.validateSlotsContinuity()) {
            this.enforceSlotsContinuity();
        }
    }
    
    validateName() {
        const name = this.userNameInput.value.trim();
        
        if (!name) {
            this.showError(this.userNameInput, 'Ім\'я не може бути порожнім');
            return false;
        }
        
        if (name.length < 2) {
            this.showError(this.userNameInput, 'Ім\'я має містити мінімум 2 символи');
            return false;
        }
        
        this.hideError(this.userNameInput);
        return true;
    }
    
    validatePhone() {
        const phone = this.userPhoneInput.value.trim();
        const phoneDigits = phone.replace(/\D/g, '');
        
        if (!phone) {
            this.showError(this.userPhoneInput, 'Номер телефону не може бути порожнім');
            return false;
        }
        
        if (phoneDigits.length < 12 || phoneDigits.length > 12) {
            this.showError(this.userPhoneInput, 'Номер телефону має бути коректним (+380XXXXXXXXX)');
            return false;
        }
        
        if (!phoneDigits.startsWith('380')) {
            this.showError(this.userPhoneInput, 'Номер має починатися з +380');
            return false;
        }
        
        const operatorCode = phoneDigits.substring(3, 5);
        const validCodes = ['39', '50', '63', '66', '67', '68', '73', '91', '92', '93', '94', '95', '96', '97', '98', '99'];
        if (!validCodes.includes(operatorCode)) {
            this.showError(this.userPhoneInput, 'Невірний код оператора');
            return false;
        }
        
        this.hideError(this.userPhoneInput);
        return true;
    }
    
    validateEmail() {
        const email = this.userEmailInput.value.trim();
        
        if (!email) {
            this.showError(this.userEmailInput, 'Email не може бути порожнім');
            return false;
        }
        
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            this.showError(this.userEmailInput, 'Будь ласка, введіть правильний email');
            return false;
        }
        
        this.hideError(this.userEmailInput);
        return true;
    }
    
    async loadSettings() {
        try {
            const response = await fetch('/wp-json/pozamezh/v1/settings');
            if (response.ok) {
                this.settings = await response.json();
                if (this.peopleCountInput && this.settings.total_stations) {
                    this.peopleCountInput.max = this.settings.total_stations;
                }
            }
        } catch (error) {
            console.error('Error loading settings:', error);
        }
    }

    getPricePerHourForSelectedDate() {
        if (!this.settings) {
            return 400;
        }

        const defaultPrice = parseFloat(this.settings.price_per_hour || 400);
        const priceLegacy = parseFloat(this.settings.price_before_switch);
        const priceMain = parseFloat(
            this.settings.price_main != null ? this.settings.price_main : this.settings.price_per_hour
        );
        const switchDate = this.settings.price_switch_date || '';

        if (!switchDate || Number.isNaN(priceLegacy) || Number.isNaN(priceMain)) {
            return defaultPrice;
        }

        let selectedDate = '';
        if (this.selectedDate) {
            if (this.selectedDate.date) {
                selectedDate = this.selectedDate.date;
            } else if (
                typeof this.selectedDate.year === 'number' &&
                typeof this.selectedDate.month === 'number' &&
                typeof this.selectedDate.day === 'number'
            ) {
                selectedDate = `${this.selectedDate.year}-${String(this.selectedDate.month + 1).padStart(2, '0')}-${String(this.selectedDate.day).padStart(2, '0')}`;
            }
        }

        if (!selectedDate) {
            return defaultPrice;
        }

        return selectedDate >= switchDate ? priceMain : priceLegacy;
    }
    
    calculatePrice() {
        if (!this.settings || this.selectedTimeSlots.length === 0) {
            return null;
        }
        
        if (!this.peopleCountInput) {
            return null;
        }
        
        if (this.appliedCertificate && this.appliedCertificate.sessions) {
            return {
                total: 0,
                original: 0,
                discount: 0,
                discountPercent: 0,
                discountReason: null,
                certificateApplied: true
            };
        }
        
        const pricePerHour = this.getPricePerHourForSelectedDate();
        const peopleCount = parseInt(this.peopleCountInput.value) || 1;
        const hours = this.selectedTimeSlots.length;
        
        let totalPrice = pricePerHour * peopleCount * hours;
        const originalPrice = totalPrice;
        let discountAmount = 0;
        let discountPercent = 0;
        
        let paymentMethod = 'online';
        if (this.form) {
            const checkedRadio = this.form.querySelector('input[name="paymentMethod"]:checked');
            paymentMethod = checkedRadio ? checkedRadio.value : 'online';
        }
        
        let appliedDiscount = false;
        let discountReason = null;
        
        const discountHoursEnabled = this.settings.discount_hours_enabled === true;
        const onlineDiscountEnabled = this.settings.online_payment_discount_enabled === true;
        
        const sessionsThreshold = this.settings.discount_hours_threshold || 3;
        const sessions = hours * peopleCount;
        const sessionsCondition = sessions >= sessionsThreshold;
        
        if (discountHoursEnabled && sessionsCondition) {
            discountPercent = this.settings.discount_hours_percent || 0;
            discountAmount = totalPrice * (discountPercent / 100);
            totalPrice -= discountAmount;
            appliedDiscount = true;
            discountReason = 'sessions';
        }
        
        const onlineCondition = paymentMethod === 'online';
        
        if (!appliedDiscount && onlineDiscountEnabled && onlineCondition) {
            discountPercent = this.settings.online_payment_discount || 0;
            discountAmount = totalPrice * (discountPercent / 100);
            totalPrice -= discountAmount;
            appliedDiscount = true;
            discountReason = 'online';
        }
        
        return {
            total: totalPrice,
            original: originalPrice,
            discount: discountAmount,
            discountPercent: discountPercent,
            discountReason: discountReason,
            certificateApplied: false
        };
    }
    
    updatePrice() {
        const priceData = this.calculatePrice();
        
        if (!priceData) {
            this.hidePrice();
            if (this.discountReasonElement) {
                this.discountReasonElement.innerHTML = '';
                this.discountReasonElement.style.display = 'none';
            }
            return;
        }
        
        this.showPrice();
        
        if (this.priceElement) {
            this.priceElement.textContent = `${Math.round(priceData.total)} ₴`;
        }
        
        if (priceData.certificateApplied && this.appliedCertificate) {
            if (this.priceRowElement) {
                this.priceRowElement.style.display = 'none';
            }
            if (this.discountReasonElement) {
                this.discountReasonElement.innerHTML = '';
                this.discountReasonElement.style.display = 'none';
            }
            this.showCertificateNotification();
            return;
        }
        
        this.hideCertificateNotification();
        
        if (priceData.discount > 0 && priceData.discountReason) {
            if (this.priceRowElement) {
                this.priceRowElement.style.display = 'flex';
            }
            if (this.priceOldElement) {
                this.priceOldElement.textContent = `${Math.round(priceData.original)} ₴`;
            }
            if (this.discountElement) {
                const totalDiscountPercent = Math.round((priceData.discount / priceData.original) * 100);
                this.discountElement.textContent = `-${totalDiscountPercent}%`;
            }
            
            if (this.discountReasonElement) {
                let reasonText = '';
                if (priceData.discountReason === 'sessions') {
                    const sessionsThreshold = this.settings.discount_hours_threshold || 3;
                    const sessions = this.selectedTimeSlots.length * (parseInt(this.peopleCountInput.value) || 1);
                    reasonText = `Застосована знижка ${priceData.discountPercent}% за бронювання від ${sessionsThreshold} сеансів`;
                } else if (priceData.discountReason === 'online') {
                    reasonText = `Застосована знижка ${priceData.discountPercent}% за онлайн оплату`;
                }
                this.discountReasonElement.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5" fill="none"/><path d="M8 11V8M8 5H8.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>${reasonText}`;
                this.discountReasonElement.style.display = 'flex';
            }
        } else {
            if (this.priceRowElement) {
                this.priceRowElement.style.display = 'none';
            }
            if (this.priceOldElement) {
                this.priceOldElement.textContent = '';
            }
            if (this.discountElement) {
                this.discountElement.textContent = '';
            }
            if (this.discountReasonElement) {
                this.discountReasonElement.innerHTML = '';
                this.discountReasonElement.style.display = 'none';
            }
        }
    }
    
    showPrice() {
        if (this.priceWrapper) {
            this.priceWrapper.style.display = 'block';
        }
    }
    
    hidePrice() {
        if (this.priceWrapper) {
            this.priceWrapper.style.display = 'none';
        }
    }
    
    getPlacesText(count) {
        if (count === 0) return '0 місць';
        if (count === 1) return '1 місце';
        if (count >= 2 && count <= 4) return `${count} місця`;
        return `${count} місць`;
    }
    
    generateTimeSlots(startTime, endTime) {
        const slots = [];
        const start = new Date(`2000-01-01T${startTime}:00`);
        const end = new Date(`2000-01-01T${endTime}:00`);
        
        let current = new Date(start);
        
        while (current < end) {
            const slotStart = current.toTimeString().slice(0, 5);
            current.setHours(current.getHours() + 1);
            const slotEnd = current.toTimeString().slice(0, 5);
            
            if (current <= end) {
                slots.push(`${slotStart}-${slotEnd}`);
            }
        }
        
        return slots;
    }
    
    changePeopleCount(delta) {
        const currentValue = parseInt(this.peopleCountInput.value) || 1;
        let maxValue = this.getMaxPeopleForSelectedSlots();
        let newValue = currentValue + delta;
        
        if (this.appliedCertificate && this.appliedCertificate.sessions) {
            const certificateSessions = this.appliedCertificate.sessions;
            maxValue = Math.min(certificateSessions, maxValue);
            
            const hours = this.selectedTimeSlots.length;
            if (delta > 0 && hours > 0) {
                const maxPeopleForSlots = Math.floor(certificateSessions / hours);
                if (maxPeopleForSlots < newValue) {
                    newValue = Math.min(maxPeopleForSlots, maxValue);
                }
            }
            
            if (newValue > certificateSessions) {
                newValue = certificateSessions;
            }
        }
        
        if (newValue >= 1 && newValue <= maxValue) {
            this.peopleCountInput.value = newValue;
            this.validatePeopleCount();
            this.updatePrice();
        }
    }
    
    formatPhoneInput(input) {
        let value = input.value.replace(/\D/g, '');
        
        if (value.startsWith('380')) {
            value = '380' + value.substring(3);
        } else if (value.length > 0 && !value.startsWith('380')) {
            value = '380' + value;
        }
        
        if (value.length > 0) {
            let formatted = '+380 ';
            const rest = value.substring(3);
            
            if (rest.length === 0) {
                formatted = '+380 ';
            } else if (rest.length <= 2) {
                formatted += rest;
            } else if (rest.length <= 5) {
                formatted += `${rest.substring(0, 2)}-${rest.substring(2)}`;
            } else if (rest.length <= 7) {
                formatted += `${rest.substring(0, 2)}-${rest.substring(2, 5)}-${rest.substring(5)}`;
            } else {
                formatted += `${rest.substring(0, 2)}-${rest.substring(2, 5)}-${rest.substring(5, 7)}-${rest.substring(7, 9)}`;
            }
            
            input.value = formatted;
        } else {
            input.value = '';
        }
    }
    
    async checkCertificate() {
        if (!this.certificateCodeInput || !this.certificateCodeInput.value.trim()) {
            this.showError(this.certificateCodeInput, 'Будь ласка, введіть код сертифіката');
            return;
        }
        
        const certificateCode = this.certificateCodeInput.value.trim();
        const applyBtn = this.applyCertificateBtn;
        
        if (applyBtn) {
            applyBtn.disabled = true;
            const textEl = applyBtn.querySelector('.btn__text');
            const spinnerEl = applyBtn.querySelector('.btn__spinner');
            const iconEdit = applyBtn.querySelector('.btn__icon--edit');
            const iconCheck = applyBtn.querySelector('.btn__icon--check');
            if (textEl && spinnerEl) {
                if (iconEdit) iconEdit.style.display = 'none';
                if (iconCheck) iconCheck.style.display = 'none';
                spinnerEl.style.display = 'inline-flex';
            }
        }
        
        try {
            const response = await fetch('/wp-json/pozamezh/v1/check-certificate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ certificate_code: certificateCode })
            });
            
            const result = await response.json();
            
            if (!response.ok) {
                throw new Error(result.message || 'Сертифікат не знайдено або недійсний');
            }
            
            if (result.sessions) {
                this.appliedCertificate = {
                    code: certificateCode,
                    sessions: parseInt(result.sessions)
                };
                this.hideError(this.certificateCodeInput);
                
                if (this.peopleCountInput) {
                    const certificateSessions = this.appliedCertificate.sessions;
                    const maxStations = this.settings ? this.settings.total_stations : 10;
                    let currentPeopleCount = parseInt(this.peopleCountInput.value) || 1;
                    const selectedSlotsCount = this.selectedTimeSlots.length;
                    
                    if (currentPeopleCount > certificateSessions) {
                        currentPeopleCount = certificateSessions;
                    }
                    
                    if (selectedSlotsCount > 0) {
                        const maxPeopleForSlots = Math.floor(certificateSessions / selectedSlotsCount);
                        if (maxPeopleForSlots < currentPeopleCount) {
                            currentPeopleCount = Math.max(1, maxPeopleForSlots);
                        }
                    }
                    
                    currentPeopleCount = Math.min(currentPeopleCount, maxStations);
                    this.peopleCountInput.value = currentPeopleCount;
                }
                
                this.showCertificateNotification();
                if (applyBtn) {
                    applyBtn.disabled = false;
                    const textEl = applyBtn.querySelector('.btn__text');
                    const spinnerEl = applyBtn.querySelector('.btn__spinner');
                    const iconEdit = applyBtn.querySelector('.btn__icon--edit');
                    const iconCheck = applyBtn.querySelector('.btn__icon--check');
                    if (textEl && spinnerEl) {
                        textEl.textContent = 'Застосовано';
                        spinnerEl.style.display = 'none';
                        if (iconEdit) iconEdit.style.display = 'none';
                        if (iconCheck) iconCheck.style.display = 'inline-block';
                    }
                }
                this.updateSlotsAvailability();
                this.updatePrice();
                this.updatePaymentMethodVisibility();
            } else {
                throw new Error('Невірний сертифікат');
            }
        } catch (error) {
            this.showError(this.certificateCodeInput, error.message || 'Помилка при перевірці сертифіката');
            this.appliedCertificate = null;
            this.hideCertificateNotification();
            this.updatePrice();
            this.updatePaymentMethodVisibility();
            if (applyBtn) {
                applyBtn.disabled = false;
                const textEl = applyBtn.querySelector('.btn__text');
                const spinnerEl = applyBtn.querySelector('.btn__spinner');
                const iconEdit = applyBtn.querySelector('.btn__icon--edit');
                const iconCheck = applyBtn.querySelector('.btn__icon--check');
                if (textEl && spinnerEl) {
                    textEl.textContent = 'Застосувати';
                    spinnerEl.style.display = 'none';
                    if (iconEdit) iconEdit.style.display = 'inline-block';
                    if (iconCheck) iconCheck.style.display = 'none';
                }
            }
        }
    }
    
    showCertificateNotification() {
        if (!this.certificateNotificationElement || !this.appliedCertificate) {
            return;
        }
        
        const sessions = this.appliedCertificate.sessions;
        let sessionsText = '';
        if (sessions === 1) {
            sessionsText = '1 сеанс';
        } else if (sessions >= 2 && sessions <= 4) {
            sessionsText = `${sessions} сеанси`;
        } else {
            sessionsText = `${sessions} сеансів`;
        }
        
        this.certificateNotificationElement.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5" fill="none"/>
                <path d="M8 11V8M8 5H8.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <span>Сертифікат на ${sessionsText} застосовано</span>
        `;
        this.certificateNotificationElement.style.display = 'flex';
    }
    
    hideCertificateNotification() {
        if (this.certificateNotificationElement) {
            this.certificateNotificationElement.innerHTML = '';
            this.certificateNotificationElement.style.display = 'none';
        }
    }
    
    resetCertificateState() {
        this.appliedCertificate = null;
        this.hideCertificateNotification();
        
        if (this.applyCertificateBtn) {
            this.applyCertificateBtn.disabled = false;
            const btnText = this.applyCertificateBtn.querySelector('.btn__text');
            const iconEdit = this.applyCertificateBtn.querySelector('.btn__icon--edit');
            const iconCheck = this.applyCertificateBtn.querySelector('.btn__icon--check');
            if (btnText) {
                btnText.textContent = 'Застосувати';
            }
            if (iconEdit) iconEdit.style.display = 'inline-block';
            if (iconCheck) iconCheck.style.display = 'none';
        }
        
        this.selectedTimeSlots = [];
        const allCheckboxes = this.timeSlotsContainer.querySelectorAll('input[type="checkbox"]');
        allCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        
        if (this.peopleCountInput) {
            this.peopleCountInput.value = 1;
        }
        
        this.updatePrice();
        this.updatePaymentMethodVisibility();
    }
    
    updatePaymentMethodVisibility() {
        let paymentField = null;
        const fields = this.modalElement.querySelectorAll('.booking-modal__field');
        fields.forEach(field => {
            const label = field.querySelector('.booking-modal__label');
            if (label && label.textContent.includes('Метод оплати')) {
                paymentField = field;
            }
        });
        
        if (paymentField) {
            if (this.appliedCertificate) {
                paymentField.style.display = 'none';
            } else {
                paymentField.style.display = '';
            }
        }
    }
    
    resetForm() {
        this.selectedTimeSlots = [];
        this.hidePrice();
        this.clearAllErrors();
        this.appliedCertificate = null;
        this.hideCertificateNotification();
        
        if (this.priceRowElement) {
            this.priceRowElement.style.display = 'none';
        }
        
        if (this.peopleCountInput) {
            this.peopleCountInput.value = 1;
        }
        
        if (this.userNameInput) {
            this.userNameInput.value = '';
        }
        
        if (this.userPhoneInput) {
            this.userPhoneInput.value = '';
        }
        
        if (this.userEmailInput) {
            this.userEmailInput.value = '';
        }
        
        if (this.specialNeedsInput) {
            this.specialNeedsInput.value = '';
        }
        
        if (this.hasCertificateCheckbox) {
            this.hasCertificateCheckbox.checked = false;
        }
        
        if (this.certificateFieldWrapper) {
            this.certificateFieldWrapper.style.display = 'none';
        }
        
        if (this.certificateCodeInput) {
            this.certificateCodeInput.value = '';
        }
        
        if (this.form) {
            const paymentRadios = this.form.querySelectorAll('input[name="paymentMethod"]');
            paymentRadios.forEach(radio => {
                radio.checked = false;
            });
            const onlineRadio = this.form.querySelector('input[value="online"]');
            if (onlineRadio) {
                onlineRadio.checked = true;
            }
            if (this.disclaimerCheckbox) {
                this.disclaimerCheckbox.checked = false;
            }
        }
    }
    
    validateForm() {
        let isValid = true;
        this.clearAllErrors();
        
        if (this.selectedTimeSlots.length === 0) {
            isValid = false;
            this.showFormError('Будь ласка, оберіть хоча б один час для гри');
        }
        
        
        if (!this.validateName()) {
            isValid = false;
        }
        
        if (!this.validatePhone()) {
            isValid = false;
        }
        
        if (!this.validateEmail()) {
            isValid = false;
        }
        
        if (!this.disclaimerCheckbox || !this.disclaimerCheckbox.checked) {
            isValid = false;
            this.showFormError('Будь ласка, підтвердіть ознайомлення з правилами');
        }
        
        return isValid;
    }
    
    showFormError(message) {
        if (!this.errorsContainer) return;
        
        const errorEl = document.createElement('div');
        errorEl.className = 'booking-modal__error booking-modal__error--form';
        errorEl.textContent = message;
        this.errorsContainer.appendChild(errorEl);
    }
    
    clearFormError() {
        if (!this.errorsContainer) return;
        
        const formErrors = this.errorsContainer.querySelectorAll('.booking-modal__error--form');
        formErrors.forEach(error => error.remove());
    }
    
    clearFieldError(input) {
        if (!input) return;
        
        const fieldName = input.id;
        if (this.errors[fieldName]) {
            delete this.errors[fieldName];
            
            const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
            if (wrapper) {
                wrapper.classList.remove('booking-modal__input-wrapper--error', 'booking-modal__textarea-wrapper--error');
                const errorIcon = wrapper.querySelector('.booking-modal__error-icon');
                if (errorIcon) {
                    errorIcon.remove();
                }
            }
            
            this.renderErrors();
        }
        
        this.clearFormError();
    }
    
    showError(input, message) {
        if (!input || !this.errorsContainer) return;
        
        const fieldName = input.id;
        this.errors[fieldName] = message;
        
        if (fieldName === 'certificateCode') {
            const certificateWrapper = input.closest('.certificate_section__input-wrapper');
            if (certificateWrapper) {
                certificateWrapper.classList.add('certificate_section__input-wrapper--error');
            }
        } else {
            const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
            if (wrapper) {
                wrapper.classList.add('booking-modal__input-wrapper--error');
                
                if (!wrapper.querySelector('.booking-modal__error-icon')) {
                    const errorIcon = document.createElement('div');
                    errorIcon.className = 'booking-modal__error-icon';
                    errorIcon.innerHTML = `
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="8" stroke="#ff6b6b" stroke-width="1.5" fill="none"/>
                            <path d="M10 6V10" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round"/>
                            <path d="M10 14H10.01" stroke="#ff6b6b" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                    `;
                    wrapper.appendChild(errorIcon);
                }
            }
        }
        
        this.renderErrors();
    }
    
    hideError(input) {
        if (!input || !this.errorsContainer) return;
        
        const fieldName = input.id;
        delete this.errors[fieldName];
        
        if (fieldName === 'certificateCode') {
            const certificateWrapper = input.closest('.certificate_section__input-wrapper');
            if (certificateWrapper) {
                certificateWrapper.classList.remove('certificate_section__input-wrapper--error');
            }
        } else {
            const wrapper = input.closest('.booking-modal__input-wrapper, .booking-modal__textarea-wrapper');
            if (wrapper) {
                wrapper.classList.remove('booking-modal__input-wrapper--error');
                const errorIcon = wrapper.querySelector('.booking-modal__error-icon');
                if (errorIcon) {
                    errorIcon.remove();
                }
            }
        }
        
        this.renderErrors();
    }
    
    renderErrors() {
        if (!this.errorsContainer) return;
        
        const formErrors = this.errorsContainer.querySelectorAll('.booking-modal__error--form');
        const fieldErrorKeys = Object.keys(this.errors);
        
        if (formErrors.length === 0 && fieldErrorKeys.length === 0) {
            this.errorsContainer.innerHTML = '';
            return;
        }
        
        let html = '';
        
        formErrors.forEach(formError => {
            html += formError.outerHTML;
        });
        
        fieldErrorKeys.forEach(fieldName => {
            const errorEl = document.createElement('div');
            errorEl.className = 'booking-modal__error';
            errorEl.textContent = this.errors[fieldName];
            html += errorEl.outerHTML;
        });
        
        this.errorsContainer.innerHTML = html;
    }
    
    clearAllErrors() {
        if (!this.errorsContainer) return;
        
        this.errors = {};
        this.errorsContainer.innerHTML = '';
        
        const errorWrappers = this.modalElement.querySelectorAll('.booking-modal__input-wrapper--error, .booking-modal__textarea-wrapper--error');
        errorWrappers.forEach(wrapper => {
            wrapper.classList.remove('booking-modal__input-wrapper--error', 'booking-modal__textarea-wrapper--error');
            const errorIcon = wrapper.querySelector('.booking-modal__error-icon');
            if (errorIcon) {
                errorIcon.remove();
            }
        });
    }
    
    async handleSubmit() {
        if (!this.validateForm()) {
            return;
        }
        
        if (this.submitBtn.disabled) {
            return;
        }
        
        let paymentMethod = 'online';
        if (this.appliedCertificate && this.appliedCertificate.code) {
            paymentMethod = 'certificate';
        } else {
            const checkedPaymentRadio = this.form ? this.form.querySelector('input[name="paymentMethod"]:checked') : null;
            paymentMethod = checkedPaymentRadio ? checkedPaymentRadio.value : 'online';
        }
        
        const bookingData = {
            date: this.selectedDate.date || `${this.selectedDate.year}-${String(this.selectedDate.month + 1).padStart(2, '0')}-${String(this.selectedDate.day).padStart(2, '0')}`,
            time: this.selectedTimeSlots.join(', '),
            people_count: parseInt(this.peopleCountInput.value) || 1,
            customer_name: this.userNameInput.value.trim(),
            customer_phone: this.userPhoneInput.value.trim(),
            customer_email: this.userEmailInput.value.trim(),
            special_needs: this.specialNeedsInput ? this.specialNeedsInput.value.trim() : '',
            payment_method: paymentMethod,
            order_type: 'booking'
        };
        
        if (this.appliedCertificate && this.appliedCertificate.code) {
            bookingData.applied_certificate_code = this.appliedCertificate.code;
        }
        
        this.showSubmitLoader();
        
        try {
            const response = await fetch('/wp-json/pozamezh/v1/booking', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(bookingData)
            });
            
            const result = await response.json();
            
            if (!response.ok) {
                throw new Error(result.message || 'Помилка при створенні бронювання');
            }
            
            if (result.booking_id) {
                if (paymentMethod === 'online' && result.payment_url) {
                    window.location.href = result.payment_url;
                } else {
                    window.location.href = `/thank-you/?booking_id=${result.booking_id}`;
                }
            } else {
                this.modal.close();
                if (window.bookingCalendar) {
                    window.bookingCalendar.renderCalendar();
                }
            }
        } catch (error) {
            console.error('Booking error:', error);
            this.clearAllErrors();
            this.showFormError('Помилка при створенні бронювання. Спробуйте ще раз.');
            this.hideSubmitLoader();
        }
    }
    
    showSubmitLoader() {
        if (!this.submitBtn) return;
        
        this.submitBtn.disabled = true;
        const textEl = this.submitBtn.querySelector('.btn__text');
        const spinnerEl = this.submitBtn.querySelector('.btn__spinner');
        
        if (textEl && spinnerEl) {
            textEl.style.visibility = 'hidden';
            spinnerEl.style.display = 'flex';
        }
    }
    
    hideSubmitLoader() {
        if (!this.submitBtn) return;
        
        this.submitBtn.disabled = false;
        const textEl = this.submitBtn.querySelector('.btn__text');
        const spinnerEl = this.submitBtn.querySelector('.btn__spinner');
        
        if (textEl && spinnerEl) {
            textEl.style.visibility = 'visible';
            spinnerEl.style.display = 'none';
        }
    }
    getMaxPeopleForSelectedSlots() {
    if (this.selectedTimeSlots.length === 0) {
        // Якщо слоти не вибрані - беремо мінімум по всіх доступних слотах
        const allAvailable = Object.values(this.timeSlotsData).map(s => s.available).filter(a => a > 0);
        if (allAvailable.length > 0) {
            return Math.min(...allAvailable);
        }
        return this.settings ? this.settings.total_stations : 10;
    }
    
    // Беремо мінімальний available серед вибраних слотів
    let min = this.settings ? this.settings.total_stations : 10;
    this.selectedTimeSlots.forEach(slotDisplay => {
        const slotKey = slotDisplay.split('-')[0]; // "10:00-11:00" -> "10:00"
        const slotData = this.timeSlotsData[slotKey];
        if (slotData && slotData.available < min) {
            min = slotData.available;
        }
    });
    return min;
}
}

export default BookingForm;